import { products } from '../data/products';

// Sample courses data (you can move this to a separate file later)
const courses = [
  {
    id: 1,
    name: "Hackers Library Bundle",
    category: "Cybersecurity",
    instructor: "Security Expert Team",
    duration: "40 hours",
    students: 1250,
    rating: 4.8,
    price: 149,
    originalPrice: 2999,
    image: "/images/products/security/oscp.webp",
    shortDescription: "Master cybersecurity fundamentals, ethical hacking, and penetration testing with hands-on labs.",
    description: "Master cybersecurity fundamentals, ethical hacking, and penetration testing with hands-on labs.",
    features: [
      "40+ hours of video content",
      "Hands-on labs and exercises",
      "Real-world case studies",
      "Certification preparation",
      "Lifetime access",
      "Quantum cryptography",
      "Graphology & behavioral analysis"
    ],
    level: "Beginner to Advanced",
    isActive: true
  },
  {
    id: 2,
    name: "Python for Cybersecurity",
    category: "Development",
    instructor: "Python Security Pro",
    duration: "25 hours",
    students: 890,
    rating: 4.9,
    price: 999,
    originalPrice: 1999,
    image: "/images/products/security/python-security.webp",
    shortDescription: "Learn Python programming specifically for cybersecurity applications and automation.",
    description: "Learn Python programming specifically for cybersecurity applications and automation.",
    features: [
      "25+ hours of video content",
      "Security-focused Python scripts",
      "Automation projects",
      "Network security tools",
      "Code review sessions"
    ],
    level: "Intermediate"
  },
  {
    id: 3,
    name: "Advanced SOC Operations",
    category: "Cybersecurity",
    instructor: "SOC Specialist",
    duration: "35 hours",
    students: 650,
    rating: 4.7,
    price: 1299,
    originalPrice: 2499,
    image: "/images/products/security/soc-concepts.webp",
    shortDescription: "Deep dive into Security Operations Center concepts, threat hunting, and incident response.",
    description: "Deep dive into Security Operations Center concepts, threat hunting, and incident response.",
    features: [
      "35+ hours of advanced content",
      "SIEM implementation",
      "Threat hunting techniques",
      "Incident response procedures",
      "Team collaboration tools"
    ],
    level: "Advanced"
  },
  {
    id: 4,
    name: "AI & Machine Learning Fundamentals",
    category: "AI & ML",
    instructor: "AI Research Team",
    duration: "30 hours",
    students: 2100,
    rating: 4.9,
    price: 1199,
    originalPrice: 2299,
    image: "/images/products/ai/ml-handbook.webp",
    shortDescription: "Comprehensive introduction to AI and machine learning with practical applications.",
    description: "Comprehensive introduction to AI and machine learning with practical applications.",
    features: [
      "30+ hours of structured learning",
      "Hands-on ML projects",
      "TensorFlow and PyTorch",
      "Real-world applications",
      "Email support"
    ],
    level: "Beginner to Intermediate"
  },
  {
    id: 5,
    name: "Web Development Masterclass",
    category: "Development",
    instructor: "Full Stack Developer",
    duration: "45 hours",
    students: 1800,
    rating: 4.8,
    price: 1399,
    originalPrice: 2799,
    image: "/images/products/web/templates.webp",
    shortDescription: "Complete web development course covering frontend, backend, and deployment.",
    description: "Complete web development course covering frontend, backend, and deployment.",
    features: [
      "45+ hours of comprehensive content",
      "Modern frameworks (React, Node.js)",
      "Database design",
      "Deployment strategies",
      "Portfolio projects"
    ],
    level: "Beginner to Advanced"
  },
  {
    id: 6,
    name: "Digital Marketing Strategy",
    category: "Marketing",
    instructor: "Marketing Strategist",
    duration: "20 hours",
    students: 950,
    rating: 4.6,
    price: 899,
    originalPrice: 1799,
    image: "/images/products/marketing/marketing-plan.webp",
    shortDescription: "Strategic digital marketing course covering SEO, social media, and content marketing.",
    description: "Strategic digital marketing course covering SEO, social media, and content marketing.",
    features: [
      "20+ hours of strategic content",
      "SEO optimization techniques",
      "Social media strategies",
      "Content marketing plans",
      "Analytics and reporting"
    ],
    level: "All Levels"
  },
  {
    id: 7,
    name: "Business Analytics & Data Science",
    category: "Business",
    instructor: "Data Scientist",
    duration: "28 hours",
    students: 720,
    rating: 4.7,
    price: 1099,
    originalPrice: 2199,
    image: "/images/products/business/analytics-dashboard.webp",
    shortDescription: "Learn business analytics, data visualization, and decision-making with data.",
    description: "Learn business analytics, data visualization, and decision-making with data.",
    features: [
      "28+ hours of analytics content",
      "Data visualization tools",
      "Statistical analysis",
      "Business intelligence",
      "Case studies"
    ],
    level: "Intermediate"
  },
  {
    id: 8,
    name: "Ethical Hacking & Penetration Testing",
    category: "Cybersecurity",
    instructor: "Certified Ethical Hacker",
    duration: "50 hours",
    students: 580,
    rating: 4.9,
    price: 1699,
    originalPrice: 3499,
    image: "/images/products/security/zero-to-mastery.webp",
    shortDescription: "Comprehensive ethical hacking course with hands-on penetration testing labs.",
    description: "Comprehensive ethical hacking course with hands-on penetration testing labs.",
    features: [
      "50+ hours of intensive training",
      "Virtual lab environment",
      "Real-world scenarios",
      "Certification prep",
      "Career guidance"
    ],
    level: "Advanced"
  }
];

// Get unique categories from products
const getProductCategories = () => {
  const categories = [...new Set(products.map(product => product.category))];
  return categories.map(category => ({
    name: category,
    count: products.filter(product => product.category === category).length
  }));
};

// Search function
export const searchWebsite = (query) => {
  if (!query || query.trim().length < 2) {
    return [];
  }

  const searchTerm = query.toLowerCase().trim();
  const results = [];

  // Search in products
  const productResults = products.filter(product => {
    const searchableText = [
      product.name,
      product.category,
      product.shortDescription,
      product.description,
      ...product.features,
      ...Object.values(product.specifications || {})
    ].join(' ').toLowerCase();

    return searchableText.includes(searchTerm);
  });

  productResults.forEach(product => {
    results.push({
      ...product,
      type: 'product'
    });
  });

  // Search in courses
  const courseResults = courses.filter(course => {
    const searchableText = [
      course.name,
      course.category,
      course.shortDescription,
      course.description,
      course.instructor,
      course.level,
      ...course.features
    ].join(' ').toLowerCase();

    return searchableText.includes(searchTerm);
  });

  courseResults.forEach(course => {
    results.push({
      ...course,
      type: 'course'
    });
  });

  // Search in categories
  const categoryResults = getProductCategories().filter(category => {
    return category.name.toLowerCase().includes(searchTerm);
  });

  categoryResults.forEach(category => {
    results.push({
      ...category,
      type: 'category'
    });
  });

  // Sort results by relevance (exact matches first, then partial matches)
  results.sort((a, b) => {
    const aName = a.name || a.title || '';
    const bName = b.name || b.title || '';
    
    const aExactMatch = aName.toLowerCase().startsWith(searchTerm);
    const bExactMatch = bName.toLowerCase().startsWith(searchTerm);
    
    if (aExactMatch && !bExactMatch) return -1;
    if (!aExactMatch && bExactMatch) return 1;
    
    return 0;
  });

  return results.slice(0, 20); // Limit to 20 results
}; 